import React, { Suspense, FC } from "react";
import { Redirect, Switch } from "react-router-dom";
import { createBrowserHistory as createHistory, History } from "history";
import Loading from "pages/loading";
import routes, { AppRoute } from "routes";
import RouteWrapper from "routes/routeWrapper";
import "react-toastify/dist/ReactToastify.css";
import "./app.scss";

const App: FC = () => (
  <Suspense fallback={<Loading />}>
    <Switch>
      {routes.map((route: AppRoute, index: number) => {
        const { path, component: Component, layout: Layout, ...rest } = route;
        return (
          <RouteWrapper
            key={`app-route-${index}-${path}`}
            path={path}
            component={Component}
            layout={Layout}
            {...rest}
          />
        );
      })}
      <Redirect to="/app/overview" />
    </Switch>
  </Suspense>
);

export const browserHistory: History = createHistory();
export default App;
